var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { OneTimeLoginService } from './onetimelogin.service';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { BaseComponent } from '../base/base.component';
var OneTimeLoginComponent = /** @class */ (function (_super) {
    __extends(OneTimeLoginComponent, _super);
    function OneTimeLoginComponent(router, route, logger, message, page, pinService) {
        var _this = _super.call(this, router, route, logger, message, page, pinService) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.message = message;
        _this.page = page;
        _this.pinService = pinService;
        _this.model = {};
        _this.loading = false;
        return _this;
    }
    OneTimeLoginComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    OneTimeLoginComponent.prototype.authCheck = function () {
        var _this = this;
        if (this.model.pin == null && this.loading) {
            return;
        }
        this.loading = true;
        this.pinService.authCheck(this.model)
            .subscribe(function (data) {
            if (data === null) {
                return;
            }
            _this.router.navigate(['/top']);
        }, function (error) {
            _this.loading = false;
        });
    };
    OneTimeLoginComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    template: "<pa-header [navBtn]=\"false\" [unit]=\"false\"></pa-header>\n<div class=\"l-login\">\n  <main role=\"main\" class=\"main\">\n    <alertblock></alertblock>\n    <div class=\"login\">\n      <form class=\"login_form\" (ngSubmit)=\"f.form.valid && authCheck()\" #f=\"ngForm\" novalidate>\n        <dl>\n          <dt>\n            <label for=\"pin\">{{ (msg | async)['OneTimeLoginComponent.label.login'] }}</label>\n          </dt>\n          <dd>&nbsp;</dd>\n          <dd>\n            <p *ngIf=\"f.submitted && !pin.valid\" class=\"login_form_comment\">{{ (msg | async)['ColumnComponent.error.required'] }}</p>\n            <input type=\"password\" id=\"pin\" name=\"pin\" [(ngModel)]=\"model.pin\" #pin=\"ngModel\" required/>\n          </dd>\n        </dl>\n        <button [disabled]=\"loading\" type=\"submit\">{{ (msg | async)['OneTimeLoginComponent.button.login'] }}</button>\n        <div class=\"login_description\">\n          <div class=\"login_description_listWrapper\" [innerHTML]=\"(msg | async)['OneTimeLoginComponent.note']\"></div>\n        </div>\n      </form>\n    </div>\n  </main>\n  <pa-footer></pa-footer>\n</div><!-- /.l-login -->\n<loading></loading>\n"
                }] }
    ];
    /** @nocollapse */
    OneTimeLoginComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: MessageService },
        { type: PageService },
        { type: OneTimeLoginService }
    ]; };
    return OneTimeLoginComponent;
}(BaseComponent));
export { OneTimeLoginComponent };
//# sourceMappingURL=onetimelogin.component.js.map